module.exports = __webpack_public_path__ + "img/majestic_barriere.e1daa13b.jpg";